import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=0f44c955&scoped=true&"
import script from "./UnitManagement.vue?vue&type=script&lang=js&"
export * from "./UnitManagement.vue?vue&type=script&lang=js&"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=0f44c955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44c955",
  null
  
)

export default component.exports